import { ReactNode } from 'react'
import { NavLink } from 'react-router-dom'

interface MainLayoutProps {
  children: ReactNode
}

export function MainLayout({ children }: MainLayoutProps) {
  return (
    <div className="min-h-screen bg-ice flex flex-col">
      {/* Header */}
      <header className="bg-gradient-to-r from-rhs-maroon to-rhs-maroon text-white py-4 sm:py-6 border-b-4 border-rhs-gold shadow-gold">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between mb-4">
            <div>
              <h1 className="text-2xl sm:text-3xl font-heading tracking-tight">RHS CHEER ADMIN</h1>
              <p className="text-ice text-xs sm:text-sm mt-1">Content Management System</p>
            </div>
            <img
              src="/cheer-bear.png"
              alt="Cheer Bear"
              className="w-12 sm:w-16 h-auto drop-shadow-lg"
            />
          </div>

          {/* Navigation */}
          <nav className="border-t border-ice-dark/30 pt-3">
            <div className="flex gap-1 overflow-x-auto">
              {/* Roster removed from nav per booster decision (Feb 2026); backend + page still exist */}
              {[
                { to: '/calendar', label: 'Calendar' },
                { to: '/news', label: 'News' },
                { to: '/links', label: 'Links' },
                { to: '/contact', label: 'Contact' },
                { to: '/text', label: 'Site Text' },
              ].map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  className={({ isActive }) =>
                    `px-3 py-1.5 text-sm font-title rounded-md whitespace-nowrap transition-colors ${
                      isActive
                        ? 'bg-white text-rhs-maroon'
                        : 'text-ice hover:bg-white/10 hover:text-white'
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </div>
          </nav>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 py-8">{children}</main>

      {/* Footer */}
      <footer className="bg-rhs-black text-ice-light py-6 mt-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-sm">
            Roosevelt High School Cheer Team &copy; {new Date().getFullYear()}
          </p>
        </div>
      </footer>
    </div>
  )
}
